import React, { useContext, useEffect, useRef } from 'react'
// Icons
import { ReactComponent as Bedroom } from './icons/bedroom.svg'
import { ReactComponent as Kitchen } from './icons/kitchen_essentials.svg'
import { ReactComponent as Bathroom } from './icons/bath_essentials.svg'
import { ReactComponent as Close } from './icons/close.svg'
import { ReactComponent as Dining } from './icons/dining_room.svg'
import { ReactComponent as Living } from './icons/living_room.svg'
import { ReactComponent as HallIcon } from './icons/hall.svg'
import { ReactComponent as Office } from './icons/office.svg'
import { ReactComponent as Balcony } from './icons/balcony.svg'
import { ReactComponent as EversetLogo } from './icons/everset-logo.svg'
import { getPackageName } from '../../../../../helpers/packages'
import { sortByWeight } from '../../../../../helpers/rooms'
import { formatPrice } from '../../../../../helpers/price'
import { useDetectClickOutsideWithExclude } from '../../../../../hooks/useDetectClickOutsideWithExclude'
import { useScrollTop } from '../../../../../hooks/useScrollTop'
import { useAnalytics } from '../../../../../analytics/hooks/useAnalytics'
import { captureEvent } from '../../../../../analytics'
import { analyticsEvents } from '../../../../../analytics/events'
import { AppConfigContext } from '../../../../../context/AppConfig'
import { isTV } from '../../../../../helpers/screen'

function InfoModal({ onClose, pack, count, ...props }) {
  const ref = useDetectClickOutsideWithExclude(() => onClose(), ['design-picker'])

  return (
    <>
      <div className={`fixed top-[0] ${isTV() ? 'pt-[124px]' : 'pt-[100px]'} left-0 flex items-start  justify-center h-screen lg:h-[calc(100vh-30px)] w-screen lg:w-[calc(100vw-var(--sidebar-shown-width))]`}>
        <div
          className="bg-[#fff] border-[#C7CCD9] border-solid border-[1px] lg:max-h-[calc(100vh-100px-110px)] lg:h-max lg:w-[calc(100%-48px)] overflow-hidden lg:overflow-y-auto  rounded-[8px] pt-[100px] lg:py-[16px] lg:pb-0  text-left relative"
          onClick={(e) => e.stopPropagation()}
          ref={ref}
        >
          <PackageInfoContent count={count} onClose={onClose} pack={pack} />
        </div>
      </div>
    </>
  )
}

export function PackageInfoContent({ pack, count = 0, ...props }) {
  const rooms = JSON.parse(JSON.stringify(pack.room_classifications || []))

  const { sendOnLoad } = useAnalytics()

  function onClose() {
    props.onClose()
  }

  sendOnLoad(() => {
    captureEvent(analyticsEvents.PACKAGE_INFO_VIEWED)
  })

  const iconsMap = {
    living_room: <Living />,
    bedroom: <Bedroom />,
    dining: <Dining />,
    kitchen: <Kitchen />,
    bathroom: <Bathroom />,
    bath: <Bathroom />,
    hall: <HallIcon />,
    office: <Office />,
    balcony: <Balcony />,
  }

  function getRoomName(name) {
    if (name.toLowerCase() === 'housewares for kitchen + bath') {
      return (
        <div>
          Housewares for <br></br> Kitchen + Bath
        </div>
      )
    }
    if (name.toLowerCase().includes('bedroom')) {
      return name.replace(/([a-zA-Z]+)(\d+)/, '$1 $2')
    }
    return name
  }

  const { scrollRef, scrollTop } = useScrollTop()

  const { isSWApp, isEWApp, show_package_price, hide_prices, hide_vendor } = useContext(AppConfigContext)


  return (
    <>
      <button type="button" className="absolute top-[24px] right-[16px] hidden lg:inline-block" onClick={onClose}>
        <Close />
      </button>
      <div className={`lg:border-b-[1px] ${scrollTop > 0 ? 'border-[#E5E7ED]' : 'border-[transparent]'} border-solid`}>
        <div className={`${isEWApp ? 'flex justify-between items-start lg:items-end' : ''}`}>
          <div className="flex items-start  lg:px-[24px] ">
            <div className="mb-[8px]">
              <div className="text-[20px] text-[var(--brand-color)] font-semibold ">{getPackageName(pack)}</div>
              {!hide_prices && <div
                className={`${
                  isSWApp || isEWApp ? 'text-[var(--brand-color)] lg:opacity-70' : 'text-[#3D4256] lg:opacity-100'
                }  text-[14px] lg:text-[16px] font-medium `}
              >
                {isSWApp && !show_package_price && !hide_vendor && <>By {pack.vendor.display_name}</>}
                {(!isSWApp || show_package_price) && (
                  <>
                    {!isEWApp && !show_package_price ? 'Starting at ' : ''}${formatPrice(pack.price)}/mo
                  </>
                )}
              </div>}
              <div className=" mt-[10px] lg:font-light text-[14px]">
                {isEWApp ? <><span className='hidden lg:inline-block'>Products included in this package</span><span className='lg:hidden'>Products included</span></> : 'Base package includes'} ({count} items):
              </div>
            </div>
          </div>
          {isEWApp && <div className='lg:pr-[24px] lg:mb-[8px]'>
            <EversetLogo />
          </div>}
        </div>
        {/* {pack.description && <div className="my-[24px] font-light">{pack.description}</div>} */}
      </div>
      <div className="lg:max-h-[calc(100vh-340px)] lg:overflow-y-auto  lg:px-[24px]" ref={scrollRef}>
        <div className="lg:grid grid-cols-1 gap-[14px]">
          {rooms.sort(sortByWeight).map((r) => (
            <div
              className={`${
                isSWApp ? 'border-[#C7CCD9]' : 'border-[var(--brand-color)]'
              } border-solid border-[1px] rounded-[6px] px-[24px] py-[20px] mt-[32px] first:mt-[0] lg:mt-[0] flex flex-col lg:flex-row lg:items-center lg:py-[10px] 2xl:py-[16px] last:mb-[40px] portrait:last:mb-[0] lg:last:mb-[16px]`}
            >
              <div className="w-full lg:w-[160px] flex-shrink-0 lg:border-r-[1px] border-[#C7CCD9] border-solid lg:mr-[32px] lg:min-w-[200px] flex lg:block items-center lg:ml-[-24px]">
                <div className="flex justify-center  lg:mt-0 min-h-[50px] items-center lg:items-start lg:min-h-0 lg:mb-[5px]">
                  {iconsMap[r.icon]}
                </div>
                <div className="text-center font-medium ml-[16px] lg:ml-[0]">
                  {getRoomName(r.room_classification.classification_name)}
                </div>
              </div>
              {r.categories && (
                <div className="flex flex-wrap">
                  {r.categories.split(',').map((i) => (
                    <span className="bg-[#fafafa] mr-[6px] my-[3px] border-[1px] border-solid border-[#C7CCD9] text-[#3D4256] rounded-full px-[10px] py-[2px] font-normal">
                      {i}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default InfoModal
